import { Link } from "react-router-dom";

export default function AboutSection() {
  return (
    <section className="relative py-24 md:py-32 bg-background-100">
      <div className="w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <p className="text-xs md:text-sm text-primary-600 font-medium tracking-widest uppercase mb-6">
          Czym jest Kakobuy Spreadsheet?
        </p>

        <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 leading-relaxed mb-6">
          Odkryj{" "}
          <strong className="font-bold text-foreground-950">najlepszy</strong>{" "}
          kakobuy spreadsheet
          <br />
          <em className="font-heading italic text-foreground-600 font-normal">zorganizowany</em>{" "}
          i{" "}
          <em className="font-heading italic text-foreground-600 font-normal">przejrzysty</em>
          <br />
          dla polskich użytkowników
        </h2>

        <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed mb-10">
          Kakobuy spreadsheet to starannie przygotowana lista produktów, która pomaga polskim
          kupującym w organizacji zakupów z chińskich platform. Nasz przewodnik zawiera
          sprawdzone linki do produktów, porównania cen oraz wskazówki dotyczące bezpiecznych
          transakcji. Niezależnie od tego, czy szukasz butów, odzieży czy akcesoriów —
          kakobuy spreadsheet jest Twoim niezbędnym narzędziem zakupowym.
        </p>

        <Link
          to="/artykul/kakobuy-spreadsheet-przewodnik"
          className="inline-flex items-center gap-2 px-6 py-2.5 bg-secondary-100 text-secondary-800 font-medium text-sm rounded-full hover:bg-secondary-200 transition-colors whitespace-nowrap cursor-pointer"
        >
          Przeczytaj pełny przewodnik SEO
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line text-xs"></i>
          </span>
        </Link>
      </div>
    </section>
  );
}